import { useQuery } from "@tanstack/react-query";
import { getApiCcofPracticeIdPatientsPatientId } from "@/lib/api-client/endpoints/ccof-patient/ccof-patient";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { CcofPatientDetails } from "lib/api-types/schemas";
import { useRequestWrapper } from "@/lib/request/useRequestWrapper";

export const patientDetailsQueryKey = (
  practiceId: string,
  patientId: string,
) => ["patients", "details", practiceId, patientId] as const;

export function usePatientDetails(patientId: string | null) {
  const { tenantId } = useTenantRouteContext();

  const [fetchPatient] = useRequestWrapper((id: string) =>
    getApiCcofPracticeIdPatientsPatientId(tenantId, id).then((res) => res.data),
  );

  return useQuery<CcofPatientDetails>({
    queryKey: patientDetailsQueryKey(tenantId, patientId ?? ""),
    queryFn: () => fetchPatient(patientId!),
    enabled: patientId !== null,
    retry: false,
  });
}
